import { create, show, useModal } from "@ebay/nice-modal-react";
import { useState } from "react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type UserGuideGroupSwitchConfirmationModalProps = {
  activeGuideTitle: string;
  onConfirm: () => Promise<void>;
};

const UserGuideGroupSwitchConfirmationModal = create(
  function UserGuideGroupSwitchConfirmationModal({
    activeGuideTitle,
    onConfirm,
  }: UserGuideGroupSwitchConfirmationModalProps) {
    const modal = useModal();
    const [isLoading, setIsLoading] = useState(false);

    const handleOnConfirm = async () => {
      setIsLoading(true);
      try {
        await onConfirm();
        modal.resolve();
        modal.hide();
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <ConfirmationModal
        title="Switch guides?"
        confirmationButtonLabel="Continue"
        confirmationButtonVariant="primary"
        onConfirm={handleOnConfirm}
        isLoading={isLoading}
        isConfirmationDisabled={isLoading}
      >
        <ConfirmationModalMessage>
          Your progress on <strong>{activeGuideTitle}</strong> will be lost.
        </ConfirmationModalMessage>
      </ConfirmationModal>
    );
  }
);

export const showUserGuideGroupSwitchConfirmationModal = (
  props: UserGuideGroupSwitchConfirmationModalProps
) => show(UserGuideGroupSwitchConfirmationModal, props);
